var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('button',{staticClass:"focus:outline-none text-indigo-600 hover:text-indigo-900",attrs:{"type":"button"},on:{"click":_vm.showAccProduct}},[_vm._v(" View ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }